export const USER_GET_ME_REQUESTING = 'USER_GET_ME_REQUESTING';
export const USER_GET_ME_SUCCESS = 'USER_GET_ME_SUCCESS';
export const USER_GET_ME_ERROR = 'USER_GET_ME_ERROR';
